export const GET_EMPLOYEE_DETAIL_SUCCESS = '[EMPLOYEE][GET][NAME] success get employee';
export const LOADING_EMPLOYEE = '[EMPLOYEE][LOADING][DETAIL] set loading employee';

const json = {
  GET_EMPLOYEE_DETAIL_SUCCESS,
  LOADING_EMPLOYEE,
};

export default json;
